import React from 'react';

import { Svg, SvgDefs, SvgG, SvgPath, SvgStop } from '@rbilabs/universal-components';

export const GooglePlayBadge = ({
  width = '190px',
  height = '56px',
  alt = '',
}: {
  width?: string | number;
  height?: string | number;
  alt?: string;
}) => {
  return (
    <Svg
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="1.414"
      clipRule="evenodd"
      viewBox="0 0 190 56"
      width={width}
      height={height}
      accessibilityLabel={alt}
      title={alt}
    >
      <SvgG clipPath="url(#a)">
        <SvgPath
          fill="#000"
          fillRule="evenodd"
          d="M182.96 56H7.04C3.16 56 0 52.844 0 49V7c0-3.858 3.16-7 7.04-7h175.92c3.877 0 7.04 3.142 7.04 7v42c0 3.844-3.163 7-7.04 7Z"
          clipRule="evenodd"
        />
        <SvgPath
          fill="#A6A6A6"
          fillRule="evenodd"
          d="M182.96 1.12c3.255 0 5.918 2.644 5.918 5.88v42c0 3.236-2.646 5.88-5.918 5.88H7.04c-3.255 0-5.918-2.644-5.918-5.88V7c0-3.236 2.646-5.88 5.918-5.88h175.92Zm0-1.12H7.04C3.16 0 0 3.156 0 7v42c0 3.858 3.16 7 7.04 7h175.92c3.877 0 7.04-3.142 7.04-7V7c0-3.844-3.163-7-7.04-7Z"
          clipRule="evenodd"
        />
        <SvgPath
          fill="#fff"
          d="M100.092 18.525c-1.268 0-2.338-.444-3.184-1.316a4.48 4.48 0 0 1-1.286-3.212c0-1.275.433-2.353 1.286-3.209.843-.873 1.912-1.316 3.181-1.316 1.255 0 2.324.443 3.184 1.316.853.883 1.286 1.962 1.286 3.209-.013 1.277-.447 2.356-1.286 3.208-.842.88-1.912 1.32-3.181 1.32Zm-37.752 0c-1.241 0-2.318-.436-3.199-1.299-.874-.859-1.317-1.944-1.317-3.226 0-1.281.443-2.367 1.317-3.226.864-.862 1.94-1.298 3.199-1.298.615 0 1.212.122 1.786.37.562.24 1.02.569 1.36.97l.083.101-.947.93-.098-.116c-.535-.636-1.251-.946-2.199-.946-.845 0-1.583.3-2.191.893-.612.597-.923 1.38-.923 2.326 0 .946.311 1.728.923 2.325a3.04 3.04 0 0 0 2.191.894c.902 0 1.66-.3 2.251-.894.35-.35.567-.838.644-1.456h-3.038v-1.306h4.341l.018.119c.031.22.063.447.063.656 0 1.205-.364 2.179-1.084 2.898-.818.852-1.887 1.285-3.18 1.285Zm50.196-.185h-1.339l-4.1-6.553.035 1.18v5.37h-1.339V9.66h1.528l.042.066 3.855 6.172-.035-1.176V9.66h1.353v8.679Zm-22.503 0h-1.356v-7.374h-2.353V9.661h6.058v1.305h-2.353v7.374h.004Zm-4.813 0h-1.353V9.66h1.353v8.68Zm-7.602 0h-1.353v-7.374h-2.353V9.661h6.058v1.305h-2.352v7.374Zm-4.562-.014H67.87V9.66h5.187v1.305h-3.83v2.381h3.456v1.292h-3.457v2.381h3.831v1.306Zm24.845-2.015a2.995 2.995 0 0 0 2.191.908c.878 0 1.594-.297 2.192-.908.594-.593.895-1.372.895-2.31 0-.94-.301-1.722-.891-2.312a3.002 3.002 0 0 0-2.192-.908c-.877 0-1.594.297-2.188.908-.594.594-.895 1.372-.895 2.311 0 .94.297 1.721.888 2.311Z"
        />
        <SvgPath
          fill="#fff"
          fillRule="evenodd"
          d="M95.496 30.458c-3.303 0-5.98 2.503-5.98 5.956 0 3.421 2.695 5.956 5.98 5.956 3.303 0 5.981-2.52 5.981-5.956 0-3.453-2.678-5.956-5.98-5.956Zm0 9.552c-1.807 0-3.362-1.494-3.362-3.61 0-2.147 1.559-3.61 3.362-3.61 1.807 0 3.363 1.463 3.363 3.61.003 2.13-1.556 3.61-3.363 3.61Zm-13.048-9.552c-3.303 0-5.98 2.503-5.98 5.956 0 3.421 2.694 5.956 5.98 5.956 3.303 0 5.98-2.52 5.98-5.956 0-3.453-2.68-5.956-5.98-5.956Zm0 9.552c-1.807 0-3.362-1.494-3.362-3.61 0-2.147 1.558-3.61 3.362-3.61 1.807 0 3.363 1.463 3.363 3.61 0 2.13-1.556 3.61-3.363 3.61Zm-15.526-7.733v2.52h6.057c-.185 1.414-.653 2.458-1.37 3.174-.888.887-2.258 1.85-4.673 1.85-3.723 0-6.635-3.002-6.635-6.72s2.912-6.721 6.635-6.721c2.01 0 3.474.793 4.561 1.805l1.79-1.787c-1.51-1.446-3.52-2.553-6.337-2.553-5.107 0-9.392 4.155-9.392 9.242 0 5.1 4.282 9.241 9.392 9.241 2.757 0 4.827-.9 6.463-2.597 1.667-1.666 2.195-4.015 2.195-5.911 0-.59-.046-1.12-.14-1.571h-8.55c.004-.004.004.028.004.028Zm63.507 1.962c-.5-1.337-2.01-3.795-5.107-3.795-3.069 0-5.62 2.412-5.62 5.956 0 3.345 2.523 5.956 5.917 5.956 2.727 0 4.313-1.665 4.967-2.643l-2.024-1.354c-.671.995-1.604 1.647-2.929 1.647-1.339 0-2.275-.607-2.898-1.805l7.973-3.299c0 .004-.279-.663-.279-.663Zm-8.13 1.99c-.063-2.3 1.789-3.47 3.114-3.47 1.045 0 1.915.513 2.212 1.26l-5.326 2.21Zm-6.477 5.77h2.618V24.503h-2.618V42Zm-4.3-10.218h-.094c-.591-.702-1.713-1.337-3.146-1.337-2.974 0-5.715 2.615-5.715 5.973 0 3.345 2.727 5.929 5.715 5.929 1.416 0 2.555-.64 3.146-1.355h.094v.855c0 2.273-1.216 3.499-3.177 3.499-1.604 0-2.6-1.152-3.006-2.116l-2.275.95c.653 1.57 2.397 3.515 5.278 3.515 3.069 0 5.669-1.805 5.669-6.207V30.8h-2.475v.981h-.014Zm-3.006 8.229c-1.807 0-3.317-1.508-3.317-3.593 0-2.101 1.51-3.623 3.317-3.623 1.79 0 3.178 1.54 3.178 3.623.017 2.085-1.384 3.593-3.178 3.593Zm34.171-15.508h-6.26V42h2.618v-6.627h3.645c2.898 0 5.747-2.098 5.747-5.428 0-3.331-2.838-5.443-5.75-5.443Zm.077 8.428h-3.723v-6.005h3.723c1.961 0 3.069 1.616 3.069 3.002 0 1.372-1.122 3.003-3.069 3.003Zm16.166-2.504c-1.902 0-3.863.842-4.673 2.675l2.32.963c.5-.963 1.416-1.291 2.384-1.291 1.356 0 2.727.81 2.758 2.255v.185c-.468-.265-1.496-.67-2.726-.67-2.506 0-5.048 1.368-5.048 3.934 0 2.35 2.056 3.858 4.345 3.858 1.758 0 2.727-.792 3.331-1.71h.095v1.354h2.523v-6.703c0-3.121-2.321-4.85-5.309-4.85Zm-.329 9.584c-.856 0-2.055-.419-2.055-1.494 0-1.355 1.496-1.868 2.772-1.868 1.153 0 1.699.248 2.384.59a3.15 3.15 0 0 1-3.101 2.772Zm14.845-9.21-3.006 7.59h-.094l-3.115-7.59h-2.817l4.673 10.61-2.663 5.897h2.726l7.19-16.507h-2.894ZM149.88 42h2.618V24.502h-2.618V42Z"
          clipRule="evenodd"
        />
        <SvgPath
          fill="url(#b)"
          fillRule="evenodd"
          d="M14.625 10.547c-.406.437-.64 1.104-.64 1.976v30.958c0 .872.234 1.54.654 1.958l.108.094L32.112 28.19V27.8l-17.38-17.348-.107.094Z"
          clipRule="evenodd"
        />
        <SvgPath
          fill="url(#c)"
          fillRule="evenodd"
          d="m37.89 33.988-5.792-5.785v-.405l5.791-5.785.126.076 6.851 3.89c1.961 1.103 1.961 2.925 0 4.043l-6.85 3.889-.127.077Z"
          clipRule="evenodd"
        />
        <SvgPath
          fill="url(#d)"
          fillRule="evenodd"
          d="M38.015 33.91 32.098 28 14.624 45.453c.64.684 1.713.761 2.912.094l20.48-11.636Z"
          clipRule="evenodd"
        />
        <SvgPath
          fill="url(#e)"
          fillRule="evenodd"
          d="M38.015 22.09 17.536 10.47c-1.199-.684-2.275-.59-2.912.095L32.099 28l5.917-5.91Z"
          clipRule="evenodd"
        />
        <SvgPath
          fill="#000"
          fillRule="evenodd"
          d="M37.89 33.785 17.55 45.327c-1.136.653-2.15.607-2.803.014l-.109.108.109.094c.653.59 1.667.64 2.803-.014L38.03 33.91l-.14-.125Z"
          clipRule="evenodd"
          opacity={0.2}
        />
        <SvgPath
          fill="#000"
          fillRule="evenodd"
          d="m44.866 29.819-6.994 3.966.126.126 6.85-3.89c.983-.558 1.465-1.291 1.465-2.021-.06.67-.559 1.306-1.447 1.819Z"
          clipRule="evenodd"
          opacity={0.12}
        />
        <SvgPath
          fill="#fff"
          fillRule="evenodd"
          d="m17.536 10.673 27.33 15.508c.888.5 1.388 1.152 1.465 1.82 0-.73-.483-1.463-1.465-2.022L17.536 10.47c-1.96-1.121-3.551-.185-3.551 2.053v.202c0-2.241 1.59-3.16 3.551-2.053Z"
          clipRule="evenodd"
          opacity={0.25}
        />
      </SvgG>
      {/* @ts-ignore - SvgDefs children not typed for web */}
      <SvgDefs>
        <linearGradient
          id="b"
          x1={30.554}
          x2={2.743}
          y1={12.19}
          y2={19.608}
          gradientUnits="userSpaceOnUse"
        >
          <SvgStop stopColor="#00A0FF" />
          <SvgStop offset={0.007} stopColor="#00A1FF" />
          <SvgStop offset={0.26} stopColor="#00BEFF" />
          <SvgStop offset={0.512} stopColor="#00D2FF" />
          <SvgStop offset={0.76} stopColor="#00DFFF" />
          <SvgStop offset={1} stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="c"
          x1={47.423}
          x2={13.508}
          y1={28}
          y2={28}
          gradientUnits="userSpaceOnUse"
        >
          <SvgStop stopColor="#FFE000" />
          <SvgStop offset={0.409} stopColor="#FFBD00" />
          <SvgStop offset={0.775} stopColor="orange" />
          <SvgStop offset={1} stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="d"
          x1={34.798}
          x2={12.506}
          y1={31.216}
          y2={68.779}
          gradientUnits="userSpaceOnUse"
        >
          <SvgStop stopColor="#FF3A44" />
          <SvgStop offset={1} stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="e"
          x1={10.225}
          x2={20.17}
          y1={0.25}
          y2={17.026}
          gradientUnits="userSpaceOnUse"
        >
          <SvgStop stopColor="#32A071" />
          <SvgStop offset={0.069} stopColor="#2DA771" />
          <SvgStop offset={0.476} stopColor="#15CF74" />
          <SvgStop offset={0.801} stopColor="#06E775" />
          <SvgStop offset={1} stopColor="#00F076" />
        </linearGradient>
        <clipPath id="a">
          <SvgPath fill="#fff" d="M0 0h190v56H0z" />
        </clipPath>
      </SvgDefs>
    </Svg>
  );
};
